// extracted by mini-css-extract-plugin
export default {"settingsContainer":"SettingsMenu_settingsContainer__DYoKX","settingsWrapper":"SettingsMenu_settingsWrapper__-Jb88","infoSettings":"SettingsMenu_infoSettings__2+b2B"};